//  引入axios 和 qs
import axios from "axios"
import qs from "qs"
import local from "@/utils/local";


// 服务器地址
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || ''
axios.defaults.withCredentials = false
// axios.defaults.baseURL = "http://47.241.239.2:8014/api"
// axios.defaults.timeout = 5000; // 超时

// 请求拦截
axios.interceptors.request.use((config) => {

  // let token = local.get("t_k") || "" //取出本地token
  // if (token) {
  //   config.headers.Authorization = token; // 统一在请求头携带token
  // }
  let sign = localStorage.getItem("sign")
  if(sign){
    config.headers.sign = sign
  }
  return config;
});

// get请求和post请求
export default {
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params                            
      }).then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err)
      })
    })
  },
  post(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then((response) => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  }
}